// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"5ff0c237","139":"50a81f13","245":"c7d0e9b9","546":"05674731","653":"37024b58","943":"04c24e35","965":"a242e594"}[chunkId] + ".chunk.js";
};